$.fn.antiSpam = function () {
    let $th = $(this);
    if ($(this).length) {
        setTimeout(function () {
            $th.append('<input type="hidden" class="text" name="antispam" value="antispam" />');
        }, 3000);
    }
};